import { call } from 'typed-redux-saga'
import { BasePushTokenRequest } from '@dialogue/engage'

import { isWeb } from 'APP/Helpers/checkPlatform'
import { getTokensApi } from '../utils/engage'

export type RegisterDeviceTokenResult = { status: 200 } | { status: 'error'; problem: string }

export function* registerDeviceToken({
  token,
  device_id,
  platform_type,
  brand_version,
}: BasePushTokenRequest) {
  if (isWeb()) return

  try {
    const engageClient = yield* call(getTokensApi)
    const response = yield* call(engageClient.pushTokenPushTokensPut, {
      token,
      device_id,
      platform_type,
      brand_version,
    })

    if (response.status === 200) {
      return { status: response.status } satisfies RegisterDeviceTokenResult
    }

    return {
      status: 'error',
      problem: `Unexpected status ${response.status} registering device token via Engage`,
    } satisfies RegisterDeviceTokenResult
  } catch (e) {
    return {
      status: 'error',
      problem: `Error registering device token via Engage: ${e}`,
    } satisfies RegisterDeviceTokenResult
  }
}
